import Navigation from "@/components/landing/Navigation";
import Footer from "@/components/landing/Footer";

const Consulting = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <Navigation />
      <main className="pt-32 pb-16 relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
              Healthcare Consulting
            </h1>
            <p className="text-xl text-neutral-600 mb-8">
              Strategic healthcare consulting services to help organizations optimize their digital health initiatives and healthcare delivery systems.
            </p>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Expert Guidance</h2>
              <p className="text-neutral-600 mb-6">
                Our team of healthcare experts provides comprehensive consulting services to help organizations navigate the complex landscape of digital health technology and healthcare innovation.
              </p>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Consulting Services</h2>
              <ul className="list-disc list-inside text-neutral-600 space-y-2 mb-6">
                <li>Digital health strategy development</li>
                <li>Healthcare technology implementation</li>
                <li>Regulatory compliance and approval processes</li>
                <li>Clinical workflow optimization</li>
                <li>Healthcare data analytics and insights</li>
                <li>Telehealth program development</li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Industry Expertise</h2>
              <p className="text-neutral-600">
                With years of experience in healthcare technology and digital health innovation, we provide tailored solutions that align with your organization's goals while ensuring compliance with healthcare regulations and best practices.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Consulting;